module.exports = __webpack_public_path__ + "static/img/newsTop.16593b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/newsTop.png
// module id = YAh3
// module chunks = 0